import React from 'react';
import { createPortal } from 'react-dom';
import Button from '../ui/Button';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAction: () => void;
  title: string;
  description: string;
  actionText: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onAction,
  title,
  description,
  actionText,
}) => {
  if (!isOpen) return null;

  const handleAction = () => {
    onAction();
    onClose();
  };

  return createPortal(
    <div className="fixed inset-0 z-[60] overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4">
        <div className="fixed inset-0 bg-black/70 transition-opacity" onClick={onClose} />
        <div className="relative bg-surface rounded-xl shadow-2xl border border-neutral-200 max-w-sm w-full mx-auto z-10 p-6">
          <h3 className="text-lg font-semibold text-neutral-900 mb-2">{title}</h3>
          <p className="text-sm text-neutral-600 mb-6">{description}</p>
          <div className="flex justify-end gap-3">
            <Button variant="secondary" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="danger" onClick={handleAction}>
              {actionText}
            </Button>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default ConfirmationModal;
